import { ChangeDetectorRef, Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { ProfileService } from 'src/app/services/profile.service';
import { Browser } from '@capacitor/browser';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';
import { Profile } from 'src/app/shared/models/register.models';
@Component({
  selector: 'fun-register-company-shareholder',
  templateUrl: './register-company-shareholder.component.html',
  styleUrls: ['./register-company-shareholder.component.scss'],
})
export class RegisterCompanyShareholderComponent implements OnInit, OnDestroy {

  @Input() profile: Profile;

  @Output() public signedEvent = new EventEmitter<any>();
  @Output() public nextStepEvent = new EventEmitter<any>();
  @Output() public editPartnersEvent = new EventEmitter<any>();

  loading: boolean;
  url: string;
  lleidanetOpen: boolean;
  syncInterval: any;
  lleidanetId: string;
  signStatus: string;

  btnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('SIGN.BTN'),
    },
    {
      type: 'secondaryDark',
      index: 2,
      title: this.translate.instant('AUTOINVEST.FOOTER.PREV'),
    }
  ];
  text: string;
  image: number;
  adviseMsg: string;
  blockedWindow: boolean;
  step: number;

  constructor(
    private chdRef: ChangeDetectorRef,
    private profileService: ProfileService,
    private overviewProjectService: OverviewProjectService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.adviseMsg = this.translate.instant('SIGN.PROCCESS_OTHER_WINDOW');
    this.blockedWindow = false;
    this.loading = false;
    this.text = this.translate.instant('SIGN.CANCELED');
    this.image = 1;
    this.step = 0;
  }

  getShareholderUrl() {
    this.step = 1;
    this.loading = true;
    this.profileService.getShareHolderUrl().subscribe((res) => {
      this.url = res.signaturePlatformUrl;
      this.lleidanetId = res.uuid; //res.lleidanetSignatureId;
      this.loading = false;
      this.opearteLleidanet();
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  editPartnersInfo() {
    this.editPartnersEvent.emit();
    this.chdRef.detectChanges();
  }

  async opearteLleidanet() {
    this.loading = false;
    this.lleidanetOpen = true;
    let newWindow: Window | null;
    let times: number = 0;
    const lleidanetUrl = this.url;

    if (Capacitor.isNativePlatform()) {
      this.syncInterval = setInterval(() => {
        this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
          if (resp.signature_status === 'signed') {
            Browser.close();
            this.loading = true;
            this.lleidanetOpen = false;
            this.finishSign();
            clearInterval(this.syncInterval);
          }
          this.chdRef.detectChanges();
        });

        //this.chdRef.detectChanges();
      }, 2000);
      // Abrir la URL en el navegador del sistema para permitir redirecciones
      await Browser.open({ url: lleidanetUrl, presentationStyle: 'popover' });

      Browser.addListener('browserPageLoaded', () => {
        this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
          if (resp.signature_status === 'signed') {
            this.loading = true;
            this.lleidanetOpen = false;
            this.finishSign();
            Browser.close();
          }
          this.chdRef.detectChanges();
        });
      });

      Browser.addListener('browserFinished', () => {
        this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
          if (resp.signature_status === 'signed') {
            this.loading = true;
            this.lleidanetOpen = false;
            this.finishSign();
          } else {
            this.signStatus = 'KO';
            this.lleidanetOpen = false;
          }
          Browser.close();
          this.chdRef.detectChanges();
        });
      });

    } else {
      // Para la web, abre en una nueva pestaña y guarda la referencia
      newWindow = window.open(lleidanetUrl, '_blank');
      let completed = false;
      // Configurar un intervalo para escuchar el cierre de la ventana
      this.syncInterval = setInterval(() => {
        if (newWindow) {
          // Verifica si la ventana sigue abierta
          if (newWindow.closed) {
            // Aquí por si acaso debería de hacer la petición de nuevo con una variable local, controlada de la siguiente manera.
            // Si he firmado y demas la pongo a false y si no, la dejo a true y en cuanto cierre la pestaña compruebe
            clearInterval(this.syncInterval);
            this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
              if (resp.signature_status === 'signed' && !completed) {
                completed = true;
                this.loading = true;
                this.lleidanetOpen = false;
                this.finishSign();
                newWindow.close();
                this.chdRef.detectChanges();
              } else {
                // XXX Aqui como ha cerrado le debo de mostrar un mensaje en plan, oye mira, no se ha firmado, hasa que no firmes no se materializa tu inversión
                this.signStatus = 'KO';
                this.lleidanetOpen = false;
              }
              this.chdRef.detectChanges();
            });
          } else {
            // Puedes acceder a la URL actual de la nueva ventana
            try {
              // clearInterval(syncInterval);
              const newWindwUrl = newWindow.location.href;
              const parametersString = this.getUrlParameters(newWindwUrl);
              if (!newWindow.closed) {
                newWindow.close(); // Cierra la nueva ventana
                newWindow = null;
                clearInterval(this.syncInterval);
                if (parametersString.status === 'signed') {
                  this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
                    if (resp.signature_status === 'signed' && !completed) {
                      completed = true;
                      this.loading = true;
                      this.lleidanetOpen = false;
                      this.finishSign();
                    }
                    this.chdRef.detectChanges();
                  });
                  // Puedo mirar y asegurarme de que haya firmado bien
                } else {
                  // Hacer peticion para ver si ha firmado bien o no por si acaso
                  this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
                    if (resp.signature_status === 'signed' && !completed) {
                      completed = true;
                      this.loading = true;
                      this.lleidanetOpen = false;
                      this.finishSign();
                      if (!newWindow.closed) {
                        newWindow.close();
                      }
                      clearInterval(this.syncInterval);
                    }
                    this.chdRef.detectChanges();
                  });
                }
              }
            } catch (error) {
              // Peticion cada 4 veces para ver el estado de la firma.
              times++;
              if (times % 4 === 0) {
                this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
                  if (resp.signature_status === 'signed' && !completed) {
                    completed = true;
                    this.loading = true;
                    this.lleidanetOpen = false;
                    this.finishSign();
                    if (!newWindow.closed) {
                      newWindow.close();
                    }
                    clearInterval(this.syncInterval);
                  }
                  this.chdRef.detectChanges();
                });
              }
            }
          }
        } else if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          //clearInterval(this.syncInterval);
          this.adviseMsg = this.translate.instant('SIGN.WINDOW_NOT_ALLOWED');
          this.blockedWindow = true;
              times++;
              if (times % 4 === 0) {
                this.overviewProjectService.getLleidanetSignStatus(this.lleidanetId).subscribe(resp => {
                  if (resp.signature_status === 'signed' && !completed) {
                    completed = true;
                    this.loading = true;
                    this.lleidanetOpen = false;
                    this.finishSign();
                    if (!newWindow.closed) {
                      newWindow.close();
                    }
                    clearInterval(this.syncInterval);
                  }
                  this.chdRef.detectChanges();
                });
              }
          this.chdRef.detectChanges();
        }
      }, 2000);
    }
    this.chdRef.detectChanges();
  }

  getUrlParameters(url: string): Record<string, string> {
    const urlObj = new URL(url); // Crear un objeto URL
    const params = new URLSearchParams(urlObj.search); // Obtener los parámetros de búsqueda
    const paramsObject: Record<string, string> = {}; // Crear un objeto vacío para almacenar los parámetros

    // Llenar el objeto con los parámetros
    params.forEach((value, key) => {
      paramsObject[key] = value; // Asignar el valor al objeto usando la clave
    });

    return paramsObject; // Retornar el objeto de parámetros
  }

  finishSign() {
    // llamada a actualizar perfil
    const model = {
      shareholderDeclarations: this.lleidanetId
    }
    this.profileService.updateProfile(model).subscribe((res) => {
      this.text = this.translate.instant('SIGN.REGISTER_PJ_OK');
      this.image = 6;
      this.btnList = [
        {
          type: 'primaryDark',
          index: 2,
          title: this.translate.instant('AUTOINVEST.FOOTER.NEXT'),
        }
      ];
      this.signStatus = 'completed';
      this.loading = false;
      this.signedEvent.emit();
      this.chdRef.detectChanges();
    }, error => {
      console.log('error', error);
      this.chdRef.detectChanges();
    });
  }

  controlOveralBtn(id) {
    if (id === 1) {
      this.signStatus = null;
      this.opearteLleidanet();
    } else {
      this.nextStepEvent.emit();
    }
    this.chdRef.detectChanges();
  }

  ngOnDestroy() {
    clearInterval(this.syncInterval);
    this.chdRef.detectChanges();
  }

}
